/**
 * Customer app configuration.
 *
 * The API is served same-origin behind a proxy, so the base is just '/api/'. If the customer app
 * is ever hosted on a different origin from the API, set REACT_APP_API_BASE_URL at build time.
 */
const config = {
    currencySymbol: '€',
    apiBaseUrl: process.env.REACT_APP_API_BASE_URL || '/api/',
};

export default config;
